export const FILE_MAX_SIZE = 8000000;
export const DATE_FORMAT = 'dd/MM/yyyy';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ME = '/users/me';
export const BACKUP = '/users/me/backup';
export const UPDATE_PROFILE = '/users/:id';
export const UPDATE_IMAGE = '/users/:id/image';
export const UPDATE_PASSWORD = '/users/:id/password';
export const REGISTER = '/register';
export const REGISTER_PATIENT = '/patient/register';
export const RECOVER_PASSWORD = '/recover-password';
export const RESET_PASSWORD = '/reset-password';
export const LOGIN = '/login_check';
export const REFRESH_TOKEN = '/token/refresh';
export const CONFIRM_EMAIL = '/confirm-email';
export const PATIENT_CONFIRM_EMAIL = '/confirm-email/patient';
export const PATIENT_GET_COMPANY_BY_CONFIRMATION_TOKEN =
  '/confirm-email/patient/:confirmationToken/company';
export const CONTACT = '/contacts';

// company
export const COMPANY = '/companies/:companyId';
export const COMPANY_REGISTER = '/company/register';
export const COMPANY_GET_AVAILABLE_SUBSCRIPTION_PLANS =
  '/companies/:companyId/subscription-plans/available';
export const COMPANY_GET_SUBSCRIPTION_PLAN = '/companies/:companyId/subscription-plan';
export const COMPANY_EDIT = '/companies/:companyId';
export const COMPANY_METRICS = '/companies/:companyId/company-metrics';
export const COMPANY_UPDATE_PAYMENT_METHOD =
  '/companies/:companyId/subscription-plan/update-payment-method';
export const COMPANY_CANCEL_SUBSCRIPTION_PLAN = '/companies/:companyId/subscription-plan/cancel';

// doctor roles
export const DOCTOR_ROLES = '/doctor-roles';

// self performed test alerts
export const SELF_PERFORMED_TEST_ALERT_LIST = '/doctors/:doctorId/self-performed-test-alerts';
export const SELF_PERFORMED_TEST_ALERT_MARK_AS_READ =
  '/doctors/:doctorId/self-performed-test-alerts/:alertId/mark-as-read';

// doctor

export const PRIVATE_INSURANCE_PROVIDER_LIST = '/private-insurance-providers';
export const PATIENT_LIST = '/companies/:companyId/patients';
export const PATIENT = '/companies/:companyId/patients/:patientId';
export const PATIENT_RECOVER_PASSWORD =
  '/companies/:companyId/patients/:patientId/recover-password';
export const PATIENT_CREATE = '/companies/:companyId/patients';

// patient pathologies
export const TASKS_CANCELLATION_REASONS = '/tasks-cancellation-reasons';

export const GET_PATIENT_PATHOLOGY_IMPROVEMENT_HISTORY =
  '/patients/:patientId/patient-pathologies/:patientPathologyId/improvement-history';
export const POST_PATIENT_PATHOLOGY =
  '/companies/:companyId/patients/:patientId/patient-pathologies';

export const DOCTOR_LIST = '/companies/:companyId/doctors';
export const DOCTOR_CREATE = '/companies/:companyId/doctors';
export const DOCTOR = '/companies/:companyId/doctors/:doctorId';
export const DOCTOR_RECOVER_PASSWORD = '/companies/:companyId/doctors/:doctorId/recover-password';

export const POST_PATIENT_PATHOLOGY_FREQUENCY =
  '/companies/:companyId/patients/:patientId/patient-pathologies/:patientPathologyId/frequency';

export const POST_PATIENT_PATHOLOGY_MARK_AS_CURED =
  '/companies/:companyId/patients/:patientId/patient-pathologies/:patientPathologyId/is-tracked';

// pathologies

export const PATHOLOGIES = '/pathologies';
export const BODY_AREAS = '/body-areas';
export const SKIN_TYPES = '/skin-types';
export const SPOT_ORIGINS = '/spot-origins';

// tests

export const PATIENT_TESTS = '/patients/:patientId/tests';
export const TEST = '/patients/:patientId/tests/:testId';
export const TEST_MESSAGE_TO_PATIENT = '/patients/:patientId/tests/:testId/message-to-patient';
export const TEST_HIDE_IN_PATIENT_EVOLUTION =
  '/patients/:patientId/tests/:testId/hide-in-patient-evolution';
export const POST_TEST_PATHOLOGY = '/patients/:patientId/tests/:testId/pathology';
export const POST_TEST_MALIGNANCY = '/patients/:patientId/tests/:testId/malignancy';
export const TEST_REQUEST = '/patients/:patientId/tests';
export const TEST_OPTIONS = '/patients/test-options';
export const PATHOLOGIES_INFO_OF_PATIENT =
  '/patients/:patientId/patient-pathologies/pathologies-info';

// patient interactions

export const PATIENT_INTERACTIONS = '/patients/:id/interactions';

// patient pathology tasks
export const PATIENT_PATHOLOGY_TASKS = '/patients/:id/patient-pathology-tasks';
export const PATIENT_PATHOLOGY_TASK = '/patients/:patientId/patient-pathology-tasks/:taskId';

// test scoring systems
export const TEST_SCORING_SYSTEMS_FACET_VALUES =
  '/companies/:companyId/patients/:patientId/test-scoring-system-facet-values';

// events

export const EVENT_TYPES_LIST = '/event-types';
export const EVENT_LIST = '/users/:userId/events';
export const EVENT = '/users/:userId/events/:eventId';
export const EVENT_EDIT = '/doctors/:doctorId/events/:eventId';
export const EVENT_CREATE = '/doctors/:doctorId/events';
export const EVENT_DELETE = '/doctors/:doctorId/events/:eventId';

// notifications

export const NOTIFICATIONS_LIST = '/users/:userId/notifications';
export const MARK_NOTIFICATION_AS_READ =
  '/users/:userId/notifications/:notificationId/mark-as-read';

// Action Records
export const POST_PATIENT_ACTION_RECORD = '/patient-action-records';

export const DISABLE_EMAILS = '/disable-emails/:token';
